export const modern = [
  {
    number: 'HM100',
    hasModel: false
  },
  {
    number: 'HM101',
    hasModel: false
  },
  {
    number: 'HM102',
    hasModel: false
  },
  {
    number: 'HM103',
    hasModel: false
  },
  {
    number: 'HM104',
    hasModel: false
  },

]